import { useMemo } from 'react'

import { OFFER_TYPE_HOTEL } from 'constants/offer'
import { Experiments } from 'constants/experiments'
import useOfferList from 'hooks/Offers/useOfferList'
import useExperiment from 'hooks/Experiments/useExperiment'

export const ALTERNATIVE_OFFER_GROUPING_ROLLOUT = 'alternativeOfferGrouping'

interface UseDestinationAlternativeOfferGroupingParams {
  searchType: string;
  destinationId: string | undefined;
  propertySpecificSearch: boolean;
}

interface DestinationAlternativeOfferGroupingState {
  pending: boolean;
  enabled: boolean;
}

function isDestinationAlternativeOfferGroupingProbeEligible(
  offerList: Pick<App.OfferList, 'fetching' | 'error' | 'offerIds'>,
): boolean {
  return !offerList.fetching && !offerList.error && offerList.offerIds.length > 0
}

export function useDestinationAlternativeOfferGrouping({
  searchType,
  destinationId,
  propertySpecificSearch,
}: UseDestinationAlternativeOfferGroupingParams): DestinationAlternativeOfferGroupingState {
  const shouldProbe = searchType === 'destination' &&
    !!destinationId &&
    !propertySpecificSearch
  const probeFilters = useMemo((): App.OfferListFilters | undefined => {
    if (!shouldProbe || !destinationId) return undefined

    return {
      destinationId,
      offerTypes: [OFFER_TYPE_HOTEL],
      limit: 1,
    }
  }, [destinationId, shouldProbe])
  const probe = useOfferList(
    probeFilters,
    { disabled: !shouldProbe },
  )
  const pending = shouldProbe && probe.fetching
  const eligible = shouldProbe && isDestinationAlternativeOfferGroupingProbeEligible(probe)
  const { isAnyVariant } = useExperiment(
    Experiments.searchSppAlternativeOfferGrouping,
    { canActivate: eligible },
  )
  const enabled = eligible && isAnyVariant

  return useMemo(() => ({
    pending,
    enabled,
  }), [enabled, pending])
}
